import autocomplete from './autocomplete'
import breadcrumb from './breadcrumb'
import button from './button'
import calendar from './calendar'
import card from './card'
import checkbox from './checkbox'
import chips from './chips'
import confirmpopup from './confirmpopup'
import dialog from './dialog'
import divider from './divider'
import dropdown from './dropdown'
import global from './global'
import iconfield from './iconfield'
import inputtext from './inputtext'
import listbox from './listbox'
import metergroup from './metergroup'
import multiselect from './multiselect'
import progressbar from './progressbar'
import radiobutton from './radiobutton'
import ripple from './ripple'
import selectbutton from './selectbutton'
import sidebar from './sidebar'
import skeleton from './skeleton'
import splitbutton from './splitbutton'
import textarea from './textarea'
import toast from './toast'
import tooltip from './tooltip'

export default {
  global,
  directives: {
    ripple,
    tooltip
  },

  //forms
  autocomplete,
  dropdown,
  inputtext,
  calendar,
  checkbox,
  radiobutton,
  selectbutton,
  chips,
  multiselect,
  listbox,
  textarea,
  iconfield,

  //buttons
  button,
  splitbutton,

  //panels
  card,
  divider,

  //menu
  breadcrumb,

  //overlays
  dialog,
  sidebar,
  confirmpopup,

  //messages
  toast,

  //misc
  progressbar,
  skeleton,
  metergroup,
}
